import { yupResolver } from '@hookform/resolvers/yup';
import type { Addresses } from 'api/types/addresses.types';
import { useConfig } from 'context/app-config';
import Page from 'layout/page';
import useOrderStep from 'packages/shared/newOrder/hooks/useOrderStep';
import React, { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { useForm, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import type { AddressForm } from 'schemas/address-schema';
import { addressSchema } from 'schemas/address-schema';
import { useBasePath } from 'utils/router/hooks/useBasePath';

import AddressTypeRow from './AddressTypeRow';

interface LocationState extends Addresses.Geofence {
  lat: number;
  lng: number;
  placeId?: string;
  address: Addresses.Address;
}

export const AddressType: React.FC = () => {
  const location = useLocation();
  const address = location.state as LocationState;
  const navigate = useNavigate();
  const basePath = useBasePath();
  const config = useConfig();
  const { t } = useTranslation();

  const { register, control } = useForm<AddressForm>({
    resolver: yupResolver(addressSchema),
  });

  const addressType = useWatch({
    name: 'addressType',
    control,
  });

  // register inputs that don't exist
  useEffect(() => {
    register({ name: 'addressType' });
  }, [register]);

  useEffect(() => {
    if (!address || !address.id || !address.cityId || !address.label || !address.lat || !address.lng) {
      navigate('/newOrder/addAddress', { replace: true });
    }
  }, [address, navigate]);

  const handleProceed = () => {
    navigate(`${basePath}/addressFormPage?step=${1}`, {
      state: {
        ...address,
        addressType,
      },
    });
  };

  useEffect(() => {
    if (addressType) {
      handleProceed();
    }
  }, [addressType]);

  const { activeStep } = useOrderStep();
  return (
    <Page
      showStepper={config?.modules.newOrder.address.showStep}
      activeStep={activeStep}
      title={t('common.selectAddressType')}
      hasBack
      className="d-flex flex-column justify-content-between"
    >
      <Form>
        <Form.Row>
          <AddressTypeRow control={control} />
        </Form.Row>
      </Form>
    </Page>
  );
};
